export default "__VITE_ASSET__cRc3$iqV__"